import toArray from '../../_helpers/toarray.js';
// as lodash's orderBy: values first, then null, then undefined (a missing key or a null item), then NaN;
// desc flips it all
// biome-ignore lint/suspicious/noSelfCompare: only NaN differs from itself (Number.isNaN is what IE 11 lacks)
var rank = function rank(value) {
  return value === undefined ? 2 : value === null ? 1 : value !== value ? 3 : 0;
};
function compareValues(a, b) {
  var ranks = rank(a) - rank(b);
  if (ranks || rank(a)) {
    return ranks;
  }
  return a > b ? 1 : a < b ? -1 : 0;
}
// returns the items of an array-like ordered by given keys, as lodash's orderBy
export default function pureOrderBy(arr, givenKeys, orders) {
  var result = toArray(arr);
  if (!givenKeys) {
    return result;
  }
  var keys = Array.isArray(givenKeys) ? givenKeys : [givenKeys];
  var commonOrder = Array.isArray(orders) ? undefined : orders || 'asc';
  return result.sort(function (a, b) {
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var direction = (commonOrder || orders[i]) === 'desc' ? -1 : 1;
      var compared = compareValues(a == null ? void 0 : a[key], b == null ? void 0 : b[key]);
      if (compared) {
        return compared * direction;
      }
    }
    return 0;
  });
}